import React from 'react';
import { Flex, Box, Text, Heading } from '@spothero/ui';
import dayjs from 'utils/dayjs-timezone';
const EventInfo = ({ event, timezone }) => {
    const { title, starts, parkingWindow } = event;
    const eventStart = dayjs.utc(starts).tz(timezone);
    const parkingStart = dayjs.utc(parkingWindow?.starts).tz(timezone);
    return (<Flex marginBottom={4}>
            <Box marginRight={4} alignSelf="center">
                <Text color="red.700" fontSize="xs" fontWeight="bold" textTransform="uppercase">
                    {eventStart.format('MMM')}
                </Text>
                <Text fontSize="lg" fontWeight="bold" lineHeight="1">
                    {eventStart.format('DD')}
                </Text>
            </Box>
            <Box flex="1">
                <Heading as="h3" variant="h5">
                    {title}
                </Heading>
                <Text color="gray.600" fontSize="sm">
                    Parking: {parkingStart.format('h:mm A')} &rarr; 1 hr after
                    event end
                </Text>
            </Box>
        </Flex>);
};
export default EventInfo;
